import React, { useState, useEffect, useCallback, useRef } from 'react';

import { makeStyles, createTheme as createThemeV4, ThemeProvider as ThemeProviderV4 } from '@material-ui/core/styles';
import CssBaselineV4 from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import Chip from '@mui/material/Chip';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { format, isValid, parse } from 'date-fns';
import SettingsIcon from '@mui/icons-material/Settings';

import { useHistory } from "react-router-dom";
import moment from 'moment';
import SwipeableViews from 'react-swipeable-views';
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import { Tooltip, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Link } from 'react-router-dom';

import api from '../../../../../services/api';
import MenuRecursosAdministrativos from '../components/menu';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import Tab from '@material-ui/core/Tab';
import { useDropzone } from 'react-dropzone';
import { Card, CardContent } from '@mui/material';
import miniatura_pdf from '../../../../../assets/imgs/miniatura_pdf.png';
import Tabs from '@material-ui/core/Tabs';
import {
    RadioGroup,
    Radio, FormLabel
} from '@mui/material';
import { useTheme, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import CadastrarPreCotacao from './cadastrarCotacao.js';
import EditarPreCotacao from './editarCotacao.js';



const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));

const dropzoneStyles = {
    border: '2px dashed #cccccc',
    borderRadius: '4px',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '20px 0',
};

export default function CadastrarOrdemDeCompra() {

    const theme = useTheme();
    const [isDark, setIsDark] = useState(Cookies.get('darkMode') === 'true');

    useEffect(() => {
        const interval = setInterval(() => {
            const currentDarkMode = Cookies.get('darkMode') === 'true';
            if (currentDarkMode !== isDark) {
                setIsDark(currentDarkMode);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [isDark]);

    const customTheme = createTheme({
        palette: {
            mode: isDark ? 'dark' : 'light',
            ...(isDark && {
                background: {
                    default: '#121212',
                    paper: '#1e1e1e',
                },
                text: {
                    primary: '#fff',
                    secondary: '#ccc',
                },
            }),
        },
    });

    const themeV4 = createThemeV4({
        palette: {
            type: isDark ? 'dark' : 'light',
            ...(isDark && {
                background: {
                    default: '#121212',
                    paper: '#1e1e1e',
                },
                text: {
                    primary: '#fff',
                    secondary: '#ccc',
                },
            }),
        },
    });

    const today = new Date();

    // Formata a data de hoje para dd/mm/yyyy
    const formattedDate = format(today, 'dd/MM/yyyy');
    const [data, setData] = useState(formattedDate);
    const classes = useStyles();
    const history = useHistory();


    const editarPreCotacaoRef = useRef(null);

    const [projetos, setProjetos] = useState(null);

    const [projetoSelecionado, setProjetoSelecionado] = useState(null);
    const [propostaSelecionada, setPropostaSelecionada] = useState(null);


    const [contatoSelecionado, setContatoSelecionado] = useState(null);


    function handleSetContato(contato) {
        setContatoSelecionado(contato);
    }

    const [fornecedores, setFornecedores] = useState([]);
    const [fornecedorSelecionado, setFornecedorSelecionado] = useState(null);
    const [loadingFornecedores, setLoadingFornecedores] = useState(false);
    const [loadingProjetos, setLoadingProjetos] = useState(true);


    const [criadorRapido, setCriadorRapido] = useState(false);
    const [associarProjeto, setAssociarProjeto] = useState(false);

    const [descricao, setDescricao] = useState('');
    const [solicitantes, setSolicitantes] = useState('');
    const [unidades, setUnidades] = useState([]);
    const [unidadeSelecionada, setUnidadeSelecionada] = useState();

    const [tipoOrdemCompra, setTipoOrdemCompra] = useState(-1);
    const [tipoMercadoria, setTipoMercadoria] = useState(-1);

    const [colaboradores, setColaboradores] = useState([]);
    const [colaboradorSelecionado, setColaboradorSelecionado] = useState(null);

    const [descricaoImagem1, setDescricaoImagem1] = useState('');
    const [descricaoImagem2, setDescricaoImagem2] = useState('');
    const [descricaoImagem3, setDescricaoImagem3] = useState('');
    const [descricaoImagem4, setDescricaoImagem4] = useState('');


    const [descricaoVideo1, setDescricaoVideo1] = useState('');
    const [descricaoVideo2, setDescricaoVideo2] = useState('');
    const [descricaoVideo3, setDescricaoVideo3] = useState('');


    const [descricaoArquivo1, setDescricaoArquivo1] = useState('');
    const [descricaoArquivo2, setDescricaoArquivo2] = useState('');
    const [descricaoArquivo3, setDescricaoArquivo3] = useState('');

    const [imagemSelecionada1, setImagemSelecionada1] = useState(null);
    const [imagemSelecionada2, setImagemSelecionada2] = useState(null);
    const [imagemSelecionada3, setImagemSelecionada3] = useState(null);
    const [imagemSelecionada4, setImagemSelecionada4] = useState(null);


    function handleTipoOrdemCompra(opcao) {

        if (opcao === 1) {
            //  listarFornecedores();
        }

        setTipoOrdemCompra(opcao);
    }


    function handleCriadorRapido(opcao) {

        if (opcao) {
            listarFornecedores();
        }

        setCriadorRapido(opcao);
    }


    function handleAssociarProjeto(opcao) {
        console.log("handle");
        if (opcao) {
            listarProjetos();
        }

        setAssociarProjeto(opcao);
    }

    async function listarProjetos() {
        try {
            console.log("listando projetos");
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("v1/protected/projetos/listartodossimples", {
                headers: headers
            }).then(function (response) {
                console.log("listou");
                setProjetos(response.data);

                setLoadingProjetos(false);

            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar proejtos: " + _err)

        }

    }


    async function listarFornecedores() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("v1/protected/fornecedores/listarTodos", {
                headers: headers
            }).then(function (response) {
                setFornecedores(response.data);

                setLoadingFornecedores(false);

            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }


    useEffect(() => {
        // função que dispara ao ganhar foco
        const handleFocus = () => {
            listarFornecedores();
        };

        // adiciona listener
        window.addEventListener('focus', handleFocus);

        // remove listener ao desmontar
        return () => {
            window.removeEventListener('focus', handleFocus);
        };
    }, []); // [] garante que o efeito é registrado apenas uma vez


    const onDrop1 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada1(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);

    const onDrop2 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada2(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);

    const onDrop3 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada3(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);

    const onDrop4 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada4(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);



    const { getRootProps: getRootProps1, getInputProps: getInputProps1 } = useDropzone({
        onDrop: onDrop1,

        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });

    const { getRootProps: getRootProps2, getInputProps: getInputProps2 } = useDropzone({
        onDrop: onDrop2,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });
    const { getRootProps: getRootProps3, getInputProps: getInputProps3 } = useDropzone({
        onDrop: onDrop3,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });
    const { getRootProps: getRootProps4, getInputProps: getInputProps4 } = useDropzone({
        onDrop: onDrop4,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });



    const [videoSelecionado1, setVideoSelecionado1] = useState(null);
    const [videoSelecionado2, setVideoSelecionado2] = useState(null);
    const [videoSelecionado3, setVideoSelecionado3] = useState(null);


    const onDropVideo1 = useCallback((acceptedFiles) => {
        // Valida o tipo de arquivo
        if (!acceptedFiles[0].type.includes('video/mp4')) {
            alert('Apenas arquivos MP4 são permitidos.');
            return;
        }

        // Processa o arquivo PNG
        setVideoSelecionado1(acceptedFiles[0]);

    }, []);

    const onDropVideo2 = useCallback((acceptedFiles) => {
        // Valida o tipo de arquivo
        if (!acceptedFiles[0].type.includes('video/mp4')) {
            alert('Apenas arquivos MP4 são permitidos.');
            return;
        }

        // Processa o arquivo PNG
        setVideoSelecionado2(acceptedFiles[0]);
    }, []);

    const onDropVideo3 = useCallback((acceptedFiles) => {
        // Valida o tipo de arquivo
        if (!acceptedFiles[0].type.includes('video/mp4')) {
            alert('Apenas arquivos MP4 são permitidos.');
            return;
        }

        // Processa o arquivo PNG
        setVideoSelecionado3(acceptedFiles[0]);
    }, []);


    const { getRootProps: getRootVideoProps1, getInputProps: getInputVideoProps1 } = useDropzone({
        onDrop: onDropVideo1,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: '.mp4', // Restringe a aceitação apenas para arquivos .png

    });
    const { getRootProps: getRootVideoProps2, getInputProps: getInputVideoProps2 } = useDropzone({
        onDrop: onDropVideo2,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: '.mp4', // Restringe a aceitação apenas para arquivos .png

    });
    const { getRootProps: getRootVideoProps3, getInputProps: getInputVideoProps3 } = useDropzone({
        onDrop: onDropVideo3,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: '.mp4', // Restringe a aceitação apenas para arquivos .png

    });

    const [arquivoSelecionado1, setArquivoSelecionado1] = useState(null);
    const [arquivoSelecionado2, setArquivoSelecionado2] = useState(null);
    const [arquivoSelecionado3, setArquivoSelecionado3] = useState(null);

    const onDropArquivo1 = useCallback((acceptedFiles) => {
        setArquivoSelecionado1(acceptedFiles[0]);
    }, []);

    const onDropArquivo2 = useCallback((acceptedFiles) => {
        setArquivoSelecionado2(acceptedFiles[0]);
    }, []);

    const onDropArquivo3 = useCallback((acceptedFiles) => {
        setArquivoSelecionado3(acceptedFiles[0]);
    }, []);

    const { getRootProps: getRootArquivoProps1, getInputProps: getInputArquivoProps1 } = useDropzone({
        onDrop: onDropArquivo1,
        multiple: false, // Apenas um arquivo
        // accept removido → aceita qualquer tipo
    });

    const { getRootProps: getRootArquivoProps2, getInputProps: getInputArquivoProps2 } = useDropzone({
        onDrop: onDropArquivo2,
        multiple: false,
    });

    const { getRootProps: getRootArquivoProps3, getInputProps: getInputArquivoProps3 } = useDropzone({
        onDrop: onDropArquivo3,
        multiple: false,
    });

    const [value, setValue] = React.useState(0);

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);

    }


    const handleChangeIndex = (index) => {
        setValue(index);
    };


    const [loading, setLoading] = useState(true);

    const [ordemServicoSelecionada, setOrdemServicoSelecionada] = useState(null);

    const [ordensServicos, setOrdensServicos] = useState(null);



    const [logado, setLogado] = useState(null);


    function returnDescricaoEndereco(objeto) {
        var texto = objeto.logradouro + ", " + objeto.numero + ", " + " bairro " +
            objeto.bairro + ", " + objeto.cidade + " UF: " + objeto.estado + " CEP: " + objeto.cep;
        return texto;
    }


    function returnDescricaoColaborador(colaborador) {

        var endereco = returnDescricaoEndereco(colaborador);

        var texto = "Colaborador_ID: " + colaborador.id_colaborador +
            "\nCPF: " + colaborador.cpf +
            "\nNome: " + colaborador.nome + " " + colaborador.sobrenome + "\n " + endereco;
        return texto;
    }


    // Função para lidar com o "paste"
    const handlePaste = useCallback(
        (event) => {
            const clipboardItems = event.clipboardData.items;

            for (const item of clipboardItems) {
                if (item.type.startsWith("image/")) {
                    const file = item.getAsFile();
                    if (file) {
                        // Converte para PNG usando Canvas (caso necessário)
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            const img = new Image();
                            img.src = e.target.result;
                            img.onload = () => {
                                const canvas = document.createElement("canvas");
                                const ctx = canvas.getContext("2d");
                                canvas.width = img.width;
                                canvas.height = img.height;

                                // Desenha a imagem no Canvas
                                ctx.drawImage(img, 0, 0);

                                // Converte o Canvas para PNG
                                canvas.toBlob(
                                    (blob) => {
                                        const convertedFile = new File(
                                            [blob],
                                            `imagem-${Date.now()}.png`,
                                            { type: "image/png" }
                                        );

                                        // Define a próxima imagem disponível
                                        if (imagemSelecionada1 === null) {
                                            setImagemSelecionada1(convertedFile);
                                        } else if (imagemSelecionada2 === null) {
                                            setImagemSelecionada2(convertedFile);
                                        } else if (imagemSelecionada3 === null) {
                                            setImagemSelecionada3(convertedFile);
                                        } else if (imagemSelecionada4 === null) {
                                            setImagemSelecionada4(convertedFile);
                                        } else {
                                            alert("Todas as imagens já foram preenchidas!");
                                        }
                                    },
                                    "image/png",
                                    1
                                );
                            };
                        };
                        reader.readAsDataURL(file);
                    }
                }
            }
        },
        [imagemSelecionada1, imagemSelecionada2, imagemSelecionada3, imagemSelecionada4] // Adicionar dependências
    );

    // Listener para evento "paste"
    useEffect(() => {
        window.addEventListener("paste", handlePaste);
        return () => {
            window.removeEventListener("paste", handlePaste);
        };
    }, [handlePaste]);


    async function salvar() {

        if (criadorRapido) {
            if (!editarPreCotacaoRef.current) {
                console.warn("editarPreCotacaoRef ainda não foi inicializado");
                return;
            }

            if (!editarPreCotacaoRef.current.checkar()) {
                return;
            }
        }





        try {

            const formData = new FormData();


            if (associarProjeto) {

                if (projetoSelecionado) {
                    if (propostaSelecionada) {
                        formData.append('projeto_id_cad', projetoSelecionado.id_projeto);
                        formData.append('proposta_id_cad', propostaSelecionada.id_proposta);
                    } else {
                        alert("Selecione o Prposta ou desmarque a opção de Associação a um Projeto!");
                        return;
                    }
                } else {
                    alert("Selecione o Projeto ou desmarque a opção de Associação a um Projeto!");
                    return;
                }
            }


            if (descricao && descricao.length > 50) {
                // Tudo certo
                formData.append('descricao', descricao);

            } else {
                alert("Insira a descrição com mais de 50 caracteres");
                return;
            }

            if (tipoOrdemCompra < 0) {
                alert("Defina o tipo da Ordem");
                return;

            } else {
                formData.append('tipo_ordem', tipoOrdemCompra);

            }

            if (colaboradorSelecionado) {
                //analista é o proprio usuario
                formData.append('id_colaborador', colaboradorSelecionado.id_colaborador);
            } else {
                formData.append('id_colaborador', 0);

            }

            if (tipoOrdemCompra === 0) {


                if (tipoMercadoria < 0) {
                    alert("Defina o tipo de mercadoria");
                    return;

                } else {
                    formData.append('tipo_mercadoria', tipoMercadoria);

                }
            }




            //usuario: { id_usuario: Cookies.get("id_usuario") },
            formData.append('usuario.id_usuario', Cookies.get("id_usuario"));



            //            if (solicitantesSelecionados && solicitantesSelecionados.length > 0) {
            //              solicitantesSelecionados.forEach((solicitante, index) => {
            // envia como solicitantes[0].id_usuario, solicitantes[1].id_usuario ...
            //               formData.append(`solicitantes[${index}].id_usuario`, solicitante.id_usuario);
            //         });
            //   }
            formData.append("solicitantes_json", JSON.stringify(
                solicitantesSelecionados.map(s => ({ solicitante: { id_usuario: s.id_usuario } }))
            ));


            //formData.append('unidade.id_unidade', unidadeSelecionada.id_unidade);

            // Ordem de serviço (opcional)
            if (ordemServicoSelecionada) {
                // Se ordemServicoSelecionada for um objeto, você pode enviar como JSON
                formData.append('ordem_servico', JSON.stringify(ordemServicoSelecionada));
            }


            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }



            formData.append('descricao_imagem1', descricaoImagem1);
            formData.append('descricao_imagem2', descricaoImagem2);
            formData.append('descricao_imagem3', descricaoImagem3);
            formData.append('descricao_imagem4', descricaoImagem4);


            formData.append('descricao_video1', descricaoVideo1);
            formData.append('descricao_video2', descricaoVideo2);
            formData.append('descricao_video3', descricaoVideo3);

            formData.append('descricao_arquivo1', descricaoArquivo1);
            formData.append('descricao_arquivo2', descricaoArquivo2);
            formData.append('descricao_arquivo3', descricaoArquivo3);



            // Adicionar as imagens ao FormData
            formData.append('imagens', imagemSelecionada1);
            formData.append('imagens', imagemSelecionada2);
            formData.append('imagens', imagemSelecionada3);
            formData.append('imagens', imagemSelecionada4);

            formData.append('videos', videoSelecionado1);
            formData.append('videos', videoSelecionado2);
            formData.append('videos', videoSelecionado3);

            formData.append('arquivos', arquivoSelecionado1);
            formData.append('arquivos', arquivoSelecionado2);
            formData.append('arquivos', arquivoSelecionado3);


            const response = await api.post('/v1/protected/ordensdecompras/ordemdecompra/cadastrar', formData,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                // alert("Ordem de Compra Cadastrada!");
                if (criadorRapido) {
                    // alert("Agora e salvar a pre cotacao ja pronta");
                    if (!editarPreCotacaoRef.current) {
                        console.warn("editarPreCotacaoRef ainda não foi inicializado");
                        return;
                    }

                    if (!editarPreCotacaoRef.current.atualizar(cadastro_salvo.id_ordem_compra)) {
                        return;
                    }

                } else {
                    history.push({
                        pathname: "/gestao/administracao/ordensdecompras/editar/" + cadastro_salvo.id_ordem_compra,
                    })
                }
            } else {
                alert("Erro de Conexão, tente novamente mais tarde (cadastro não salvo)");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde " + _err);

        }



    }




    function handleSetProjeto(projeto) {
        setProjetoSelecionado(projeto);
    }


    function handleSetProposta(proposta) {
        setPropostaSelecionada(proposta);
    }


    function returnDescricaoInstalacao(instalacao) {
        var texto = "SIGMA: " + instalacao.identificador_integrador + "\nCPF/CNPJ: " + (instalacao.tipo_instalacao === 0 ? instalacao.cpf : instalacao.cnpj) +
            "\n" + (instalacao.tipo_instalacao === 0 ? (instalacao.nome + " " + instalacao.sobrenome) : instalacao.nome_fantasia);

        return texto;
    }

    function returnDescricaoProjeto(projeto) {
        try {
            if (!projeto) return "Projeto não informado";

            const texto =
                (projeto.id_projeto || "") + " - " + (projeto.nome_projeto || "") + "<br>" +
                (projeto.descricao_projeto || "") + "<br>" +
                (projeto.instalacao ? returnDescricaoInstalacao(projeto.instalacao) : "");

            return texto;
        } catch (e) {
            console.error("Erro ao montar descrição do projeto:", e);
            return "Erro ao obter dados do projeto";
        }
    }

    function returnDescricaoProposta(proposta) {
        var texto = proposta.id_proposta + " - " + proposta.descricao_proposta;
        return texto;
    }



    async function listarInformacoes() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }



            await api.get("v1/protected/user/listartodos", {
                headers: headers
            }).then(function (response) {
                setSolicitantes(response.data)


                api.get("/v1/protected/user/retornardadosusuario/" + Cookies.get("id_usuario"), {
                    headers: headers
                }).then(function (response) {
                    setLogado(response.data);
                    setSolicitantesSelecionados([...solicitantesSelecionados, response.data]);

                });


                api.get("/v1/protected/colaboradores/listartodos", {
                    headers: headers
                }).then(function (response) {
                    setColaboradores(response.data);
                });


                setLoading(false);

            });


        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar os Solicitantes: " + _err)

        }

    }

    useEffect(() => {




        listarInformacoes();


    }, []);



    const [solicitantesSelecionados, setSolicitantesSelecionados] = useState([]);

    const handleAdicionarSolicitante = (event, newValue) => {
        // Verifica se o valor selecionado já está na lista
        const valoresSelecionados = Array.isArray(newValue) ? newValue : [newValue];
        const novosSolicitantes = valoresSelecionados.filter(
            (opcao) => !solicitantesSelecionados.some((selecionado) => selecionado.id_usuario === opcao.id_usuario)
        );

        setSolicitantesSelecionados([...solicitantesSelecionados, ...novosSolicitantes]);
    };


    const handleRemoverSolicitante = (event, solicitanteRemovido) => {
        const novosSolicitantes = solicitantesSelecionados.filter(
            (solicitante) => solicitante.id_usuario !== solicitanteRemovido.id_usuario
        );
        setSolicitantesSelecionados(novosSolicitantes);
    };



    function returnDescricaoSolicitante(usuario) {
        var texto = "ID_Usuario: " + usuario.id_usuario + "\n Nome: " + usuario.nome_amigavel;
        return texto;
    }


    const handleOrdemServico = (event, ordem) => {

        setOrdemServicoSelecionada(ordem);
    };



    function returnDescricaoOrdem(ordem) {
        var texto = "ID: " + ordem.id_ordem_servico + "\n Solicitação: " + ordem.solicitacao.solicitacao;
        return texto;
    }

    const handleUnidade = (event, unidade) => {

        setUnidadeSelecionada(unidade);
    };









    function returnDescricaoContato(contato) {



        var texto = "ID: " + contato.id_contato + " Nome: " + contato.nome_contato + " Cargo: " + contato.cargo_contato;
        texto += "\nContato: " + contato.celular_contato;

        texto += (contato.whatsapp === 0 ? "" : "(Whatsapp)");

        texto += "\nFixo: " + contato.fixo_contato;
        texto += "\nE-mail: " + contato.e_mail_contato;
        texto += (contato.recebe_ordens === 0 ? "\nNão Recebe Ordens de Compra" : "\nRecebe Ordens de Compra");
        texto += "\nDescrição: " + contato.descricao_contato;


        return texto;
    }



    function returnDescricaoFornecedor(fornecedor) {

        var identificacao = fornecedor.tipo_fornecedor === 0 ? "CPF " : "CNPJ;"

        var valor = fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj;

        var nome = fornecedor.tipo_fornecedor === 0 ? (fornecedor.nome + " " + fornecedor.sobrenome) :
            (fornecedor.nome_fantasia);

        var endereco = fornecedor.logradouro + ", nº " + fornecedor.numero + ", " + fornecedor.bairro + ", " + fornecedor.cidade + " " + fornecedor.estado + " CEP: " + fornecedor.cep;


        var texto = "ID: " + fornecedor.id_fornecedor + "\n" + identificacao + " " + valor + "\n " + nome + "\n Endereço: " + endereco;
        return texto;
    }



    function returnDescricaoUnidade(unidade) {



        var nome = unidade.nome_fantasia;

        var endereco = unidade.logradouro + ", nº " + unidade.numero + ", " + unidade.bairro + ", " + unidade.cidade + " " + unidade.estado + " CEP: " + unidade.cep;


        var texto = nome + " | " + unidade.cnpj;
        return texto;
    }




    return (
        <ThemeProvider theme={customTheme}>
            <ThemeProviderV4 theme={themeV4}>
                <CssBaseline />
                <CssBaselineV4 />
                <div style={{
                    backgroundColor: isDark ? '#121212' : 'white',
                    color: isDark ? 'white' : 'black',
                    minHeight: '100vh',
                    paddingBottom: 20
                }}>
                    <NavegadorGestao
                        Gestao={true}
                        OrdensCompras={true}
                        corFundo={isDark ? '#1e1e1e' : 'white'} travado={true} corTexto={isDark ? 'white' : 'black'}
                    />
                    <div style={{ paddingTop: 5 }} />
                    {loading ?
                        <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                        </Skeleton>
                        :



                        <Grid container spacing={2} item xs={12}  >
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                align="flex-start"
                                item xs={12}
                                style={{ width: '100%', margin: 0, padding: 0 }}
                            >

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    align="flex-start"
                                    item xs={12}
                                    style={{ width: '100%', margin: 0, padding: 0 }}
                                >

                                    <a href={"/gestao/administracao/ordensdecompras/listar"} style={{ fontSize: 14, color: isDark ? 'white' : 'black', marginRight: '5px', paddingTop: 10 }}>{"< Ordens de Compra | "}</a>
                                    <span style={{ fontSize: 18, color: isDark ? 'white' : 'black', marginRight: '5px', paddingTop: 10 }}>{" Nova Ordem de Compra"}</span>

                                </Grid>

                                <Grid
                                    item xs={12}
                                    container
                                    direction="row"
                                    alignItems="center"
                                    justifyContent={"center"}
                                >
                                    <Box style={{ backgroundColor: isDark ? '#1e1e1e' : 'white', width: '100%', alignItems: 'center', }}>
                                        <AppBar position="static" >

                                            <Tabs
                                                value={value}
                                                onChange={handleChangeTab}
                                                indicatorColor="secondary"
                                                textColor="inherit"
                                                variant="scrollable"
                                                scrollButtons="auto"
                                                aria-label="scrollable auto tabs example"


                                            >
                                                <Tab label="Informações Iniciais" style={{ backgroundColor: isDark ? '#1C1C1C' : '#e0e0e0', color: isDark ? 'white' : 'black' }} />
                                                <Tab label="Imagens" style={{ backgroundColor: 'green', color: 'white' }} />
                                                <Tab label="Vídeos" style={{ backgroundColor: 'green', color: 'white' }} />
                                                <Tab label="Documentos" style={{ backgroundColor: 'green', color: 'white' }} />

                                            </Tabs>
                                        </AppBar>

                                    </Box>
                                </Grid>

                                <SwipeableViews
                                    index={value}
                                    onChangeIndex={handleChangeIndex}
                                    style={{ backgroundColor: isDark ? '#121212' : 'white', width: '100%', alignItems: 'center', }}
                                >

                                    <Grid
                                        value={value} index={0}
                                        style={{ padding: 40 }}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        spacing={2}
                                    >
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            alignItems="center"
                                            item xs={9}
                                            spacing={2}
                                        >
                                            {/* Tipo de Ordem de Compra */}
                                            <Grid item xs={12}>
                                                <FormControl component="fieldset" fullWidth>
                                                    <FormLabel component="legend" sx={{ fontWeight: 'bold', color: isDark ? 'white' : 'text.primary' }}>
                                                        Tipo de Ordem de Compra
                                                    </FormLabel>
                                                    <RadioGroup
                                                        row
                                                        value={tipoOrdemCompra}
                                                        onChange={(e) => handleTipoOrdemCompra(parseInt(e.target.value))}
                                                        sx={{ mt: 1 }}
                                                    >
                                                        <FormControlLabel
                                                            value={-1}
                                                            control={<Radio color="primary" />}
                                                            label="Opção"
                                                        />
                                                        <FormControlLabel
                                                            value={0}
                                                            control={<Radio color="primary" />}
                                                            label="Ordem de Compra"
                                                        />
                                                        <FormControlLabel
                                                            value={1}
                                                            control={<Radio color="primary" />}
                                                            label="Solicitação de Pagamento"
                                                        />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Grid>

                                            {/* Tipo de Mercadoria - Condicional */}
                                            {tipoOrdemCompra === 0 && (
                                                <Grid item xs={12}>
                                                    <FormControl component="fieldset" fullWidth>
                                                        <FormLabel component="legend" sx={{ fontWeight: 'bold', color: isDark ? 'white' : 'text.primary' }}>
                                                            Tipo de Mercadoria
                                                        </FormLabel>
                                                        <RadioGroup
                                                            row
                                                            value={tipoMercadoria}
                                                            onChange={(e) => setTipoMercadoria(parseInt(e.target.value))}
                                                            sx={{ mt: 1 }}
                                                        >
                                                            <FormControlLabel
                                                                value={-1}
                                                                control={<Radio color="secondary" />}
                                                                label="Opção"
                                                            />
                                                            <FormControlLabel
                                                                value={0}
                                                                control={<Radio color="secondary" />}
                                                                label="Receberei mercadoria física ou digital"
                                                            />
                                                            <FormControlLabel
                                                                value={1}
                                                                control={<Radio color="secondary" />}
                                                                label="Não receberei mercadoria"
                                                            />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>
                                            )}
                                        </Grid>

                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            item xs={1}
                                        >
                                            <Button style={{ marginTop: 5 }}
                                                variant="contained"
                                                color="primary"
                                                onClick={salvar}
                                            > Salvar  </Button>
                                        </Grid>


                                        <Grid item xs={9}>
                                            <TextField
                                                variant="standard"
                                                name="descricao"
                                                label="Descrição"
                                                inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                required
                                                id="descricao"
                                                value={descricao}
                                                onChange={(e) => setDescricao(e.target.value)}
                                                fullWidth
                                                multiline
                                                minRows={2}
                                            />
                                        </Grid>

                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            align="center"
                                            item xs={2}
                                            style={{ marginTop: 1 }}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={associarProjeto}
                                                        onChange={(e) => handleAssociarProjeto(e.target.checked)}
                                                        color="primary"
                                                    />
                                                }
                                                label="Associar a um Projeto"
                                            />

                                        </Grid>


                                        {associarProjeto && !loadingProjetos && projetos && (


                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="center"
                                                align="center"
                                                item xs={12}
                                                style={{ marginTop: 1 }}
                                                spacing={2}
                                            >
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="flex-end"
                                                    align="flex-end"
                                                    item xs={6}
                                                    style={{ marginTop: 1 }}
                                                >
                                                    <Grid
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        align="center"
                                                        item xs={8}
                                                    >

                                                        <Autocomplete
                                                            id="select-projeto"
                                                            options={projetos}
                                                            getOptionLabel={(projeto) => returnDescricaoProjeto(projeto).replace(/<br \/>/g, '\n')}
                                                            value={projetoSelecionado}
                                                            onChange={(e, v) => handleSetProjeto(v)}
                                                            filterOptions={(options, { inputValue }) => {
                                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                return options.filter((cotacao) => {
                                                                    const cotacaoText = returnDescricaoProjeto(cotacao).toLowerCase();
                                                                    return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                                });
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField {...params} label=" Projeto " multiline minRows={3}
                                                                    inputProps={{ ...params.inputProps, style: { color: isDark ? 'white' : 'black' } }}
                                                                    InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                />
                                                            )}
                                                            renderOption={(option) => (
                                                                <div dangerouslySetInnerHTML={{ __html: returnDescricaoProjeto(option) }} />
                                                            )}
                                                        />
                                                    </Grid>
                                                </Grid>




                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="flex-start"
                                                    align="flex-start"
                                                    item xs={6}
                                                    style={{ marginTop: 1 }}
                                                >
                                                    {
                                                        projetoSelecionado &&
                                                        <Grid
                                                            container
                                                            direction="column"
                                                            justifyContent="center"
                                                            align="center"
                                                            item xs={8}
                                                        >

                                                            <Autocomplete
                                                                id="select-proposta"
                                                                options={projetoSelecionado.propostas}
                                                                getOptionLabel={(proposta) => returnDescricaoProposta(proposta).replace(/<br \/>/g, '\n')}
                                                                value={propostaSelecionada}
                                                                onChange={(e, v) => handleSetProposta(v)}
                                                                filterOptions={(options, { inputValue }) => {
                                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                    return options.filter((cotacao) => {
                                                                        const cotacaoText = returnDescricaoProposta(cotacao).toLowerCase();
                                                                        return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                                    });
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField {...params} label=" Proposta " multiline minRows={3} />
                                                                )}
                                                                renderOption={(option) => (
                                                                    <div dangerouslySetInnerHTML={{ __html: returnDescricaoProposta(option) }} />
                                                                )}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>



                                            </Grid>

                                        )}




                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            align="center"
                                            item xs={3}
                                            style={{ marginTop: 1 }}
                                        >
                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                align="center"
                                                item xs={12}
                                            >

                                                <Autocomplete
                                                    id="select-solicitantes"
                                                    options={solicitantes}
                                                    disableCloseOnSelect
                                                    multiple
                                                    getOptionLabel={(solicitante) => returnDescricaoSolicitante(solicitante).replace(/<br \/>/g, '\n')}
                                                    value={solicitantesSelecionados}
                                                    onChange={handleAdicionarSolicitante}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                        return options.filter((solicitante) => {
                                                            const cotacaoText = returnDescricaoSolicitante(solicitante).toLowerCase();
                                                            return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label=" Solicitantes " multiline minRows={2}
                                                            inputProps={{ ...params.inputProps, style: { color: isDark ? 'white' : 'black' } }}
                                                            InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                        />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoSolicitante(option) }} />
                                                    )}
                                                    renderTags={(value, getTagProps) =>
                                                        value.map((solicitante, index) => (
                                                            <Chip
                                                                label={returnDescricaoSolicitante(solicitante)}
                                                                {...getTagProps({ index })}
                                                                onDelete={(event) => handleRemoverSolicitante(event, solicitante)}
                                                            />
                                                        ))
                                                    }
                                                />
                                            </Grid>
                                        </Grid>


                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            align="center"
                                            item xs={3}
                                            style={{ marginTop: 1 }}
                                        >
                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                align="center"
                                                item xs={12}
                                            >

                                                <Autocomplete
                                                    id="select-ordem-servico"
                                                    options={ordensServicos || []}
                                                    disableCloseOnSelect
                                                    getOptionLabel={(ordem) => returnDescricaoOrdem(ordem).replace(/<br \/>/g, '\n')}
                                                    value={ordemServicoSelecionada}
                                                    onChange={handleOrdemServico}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                        return options.filter((ordem) => {
                                                            const cotacaoText = returnDescricaoOrdem(ordem).toLowerCase();
                                                            return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label=" Ordem de Serviço " multiline minRows={2}
                                                            inputProps={{ ...params.inputProps, style: { color: isDark ? 'white' : 'black' } }}
                                                            InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                        />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoOrdem(option) }} />
                                                    )}

                                                />
                                            </Grid>
                                        </Grid>



                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            align="center"
                                            item xs={3}
                                            style={{ marginTop: 1 }}
                                        >
                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                align="center"
                                                item xs={12} >
                                                <Autocomplete
                                                    id="select-colaborador"
                                                    options={colaboradores}
                                                    disableCloseOnSelect
                                                    getOptionLabel={(colaborador) => returnDescricaoColaborador(colaborador)}
                                                    value={colaboradorSelecionado}
                                                    onChange={(e, v) => setColaboradorSelecionado(v)}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label=" Colaborador "
                                                            inputProps={{ ...params.inputProps, style: { color: isDark ? 'white' : 'black' } }}
                                                            InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                            multiline
                                                            minRows={2} />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            align="center"
                                            item xs={1}
                                            style={{ marginTop: 1 }}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={criadorRapido}
                                                        onChange={(e) => handleCriadorRapido(e.target.checked)}
                                                        color="primary"
                                                    />
                                                }
                                                label="Criador Rápido"
                                            />

                                        </Grid>






                                        {criadorRapido && !loadingFornecedores && (

                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="center"
                                                align="center"
                                                item xs={12}
                                                style={{ marginTop: 5 }}
                                            >


                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="center"
                                                    align="center"
                                                    item xs={12}
                                                >

                                                    <Tooltip style={{ paddingRight: 5 }} title="Novo Fornecedor">
                                                        <IconButton
                                                            component="a"
                                                            href="/gestao/operacional/almoxarifado/cadastrarfornecedor/1"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            sx={{
                                                                color: 'white',
                                                                backgroundColor: '#4caf50',
                                                                '&:hover': { backgroundColor: '#388e3c' },
                                                                marginLeft: 1,
                                                                width: 40,   // largura fixa
                                                                height: 40,  // altura fixa
                                                                minWidth: 40,
                                                                minHeight: 40,
                                                                padding: 0,  // remove padding extra
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',

                                                            }}
                                                        >
                                                            <AddIcon fontSize="medium" />
                                                        </IconButton>
                                                    </Tooltip>


                                                    <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <Autocomplete
                                                            id="select-fornecedor_cotacao1"
                                                            options={fornecedores}
                                                            disableCloseOnSelect
                                                            getOptionLabel={(fornecedor) => returnDescricaoFornecedor(fornecedor).replace(/<br \/>/g, '\n')}
                                                            value={fornecedorSelecionado}
                                                            getOptionSelected={(option, value) => true}
                                                            onChange={(e, v) => setFornecedorSelecionado(v)}
                                                            filterOptions={(options, { inputValue }) => {
                                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                return options.filter((fornecedor) => {
                                                                    const cotacaoText = returnDescricaoFornecedor(fornecedor).toLowerCase();
                                                                    return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                                });
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField {...params} label=" Fornecedor " multiline minRows={2}
                                                                    inputProps={{ ...params.inputProps, style: { color: isDark ? 'white' : 'black' } }}
                                                                    InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                />
                                                            )}
                                                            renderOption={(option) => (
                                                                <div dangerouslySetInnerHTML={{ __html: returnDescricaoFornecedor(option) }} />
                                                            )}
                                                            sx={{ flex: 1 }}
                                                        />

                                                        {/* Botão Gerenciar Fornecedor */}
                                                        {fornecedorSelecionado && (
                                                            <Tooltip title="Gerenciar Fornecedor" style={{ paddingLeft: 8 }}>
                                                                <IconButton
                                                                    component="a"
                                                                    href={`/gestao/operacional/almoxarifado/fornecedores/gerenciarfornecedor/${fornecedorSelecionado.id_fornecedor}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    sx={{
                                                                        color: 'white',
                                                                        backgroundColor: '#1976d2', // azul
                                                                        '&:hover': { backgroundColor: '#1565c0' }, // azul escuro no hover
                                                                        width: 40,
                                                                        height: 40,
                                                                        minWidth: 40,
                                                                        minHeight: 40,
                                                                        padding: 0,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        marginLeft: 1,
                                                                    }}
                                                                >
                                                                    <SettingsIcon fontSize="medium" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        )}
                                                    </Grid>

                                                    <Grid

                                                        item xs={4}
                                                    >
                                                        <Autocomplete
                                                            id="select-vendedor"
                                                            options={fornecedorSelecionado ? fornecedorSelecionado.contatos : []}
                                                            getOptionLabel={(vendedor) => returnDescricaoContato(vendedor).replace(/<br \/>/g, '\n')}
                                                            value={contatoSelecionado}
                                                            onChange={(e, v) => setContatoSelecionado(v)}
                                                            getOptionSelected={(option, value) => true}
                                                            filterOptions={(options, { inputValue }) => {
                                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                return options.filter((vendedor) => {
                                                                    const cotacaoText = returnDescricaoContato(vendedor).toLowerCase();
                                                                    return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                                });
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField {...params} label=" Vendedor " multiline minRows={2}
                                                                    inputProps={{ ...params.inputProps, style: { color: isDark ? 'white' : 'black' } }}
                                                                    InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                />
                                                            )}
                                                            renderOption={(option) => (
                                                                <div dangerouslySetInnerHTML={{ __html: returnDescricaoContato(option) }} />
                                                            )}
                                                            disableCloseOnSelect

                                                        />
                                                    </Grid>
                                                    <Grid
                                                        item xs={2}
                                                    >
                                                        <TextField
                                                            label="Data"
                                                            type="text"
                                                            value={data}
                                                            inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                            InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                            onChange={(e) => setData(e.target.value)}
                                                        />
                                                    </Grid>

                                                </Grid>

                                                {fornecedorSelecionado && contatoSelecionado && (
                                                    <Grid

                                                        item xs={12}
                                                    >
                                                        <EditarPreCotacao dataInformada={data} ref={editarPreCotacaoRef} flag={1} fornecedorJaSelecionado={fornecedorSelecionado} vendedorJaSelecionado={contatoSelecionado} />
                                                    </Grid>
                                                )}

                                            </Grid>


                                        )}

                                    </Grid>


                                    <Grid
                                        value={value} index={1}
                                        style={{ paddingTop: 30 }}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        spacing={2}
                                    >




                                        <Grid item xs={12} style={{ padding: 40 }}
                                            container
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <Grid item xs={3}>
                                                <Card>
                                                    <CardContent>
                                                        {imagemSelecionada1 ? (
                                                            <img
                                                                src={URL.createObjectURL(imagemSelecionada1)}
                                                                alt="Imagem Selecionada 1"
                                                                style={{ width: '100%', height: 'auto', marginBottom: '10px' }}
                                                            />
                                                        ) : (
                                                            <div {...getRootProps1()} style={dropzoneStyles}>
                                                                <input {...getInputProps1()} />
                                                                <Typography align="center" variant="h5">
                                                                    Arraste e solte uma imagem aqui ou clique para adicionar
                                                                </Typography>
                                                            </div>
                                                        )}
                                                        <Grid item xs={12} style={{ padding: 40 }}>
                                                            <TextField
                                                                variant="standard"
                                                                name="descricaoImagem1"
                                                                label="Descrição"
                                                                inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                required
                                                                id="descricaoImagem1"
                                                                value={descricaoImagem1}
                                                                onChange={(e) => setDescricaoImagem1(e.target.value)}
                                                                fullWidth
                                                                multiline
                                                                minRows={1}
                                                            />
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>

                                            <Grid item xs={3}>
                                                <Card>
                                                    <CardContent>
                                                        {imagemSelecionada2 ? (
                                                            <img
                                                                src={URL.createObjectURL(imagemSelecionada2)}
                                                                alt="Imagem Selecionada 2"
                                                                style={{ width: '100%', height: 'auto', marginBottom: '10px' }}
                                                            />
                                                        ) : (
                                                            <div {...getRootProps2()} style={dropzoneStyles}>
                                                                <input {...getInputProps2()} />
                                                                <Typography align="center" variant="h5">
                                                                    Arraste e solte uma imagem aqui ou clique para adicionar
                                                                </Typography>
                                                            </div>
                                                        )}
                                                        <Grid item xs={12} style={{ padding: 40 }}>
                                                            <TextField
                                                                variant="standard"
                                                                name="descricaoImagem2"
                                                                label="Descrição"
                                                                inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                required
                                                                id="descricaoImagem2"
                                                                value={descricaoImagem2}
                                                                onChange={(e) => setDescricaoImagem2(e.target.value)}
                                                                fullWidth
                                                                multiline
                                                                minRows={1}
                                                            />
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>

                                            <Grid item xs={3}>
                                                <Card>
                                                    <CardContent>
                                                        {imagemSelecionada3 ? (
                                                            <img
                                                                src={URL.createObjectURL(imagemSelecionada3)}
                                                                alt="Imagem Selecionada 3"
                                                                style={{ width: '100%', height: 'auto', marginBottom: '10px' }}
                                                            />
                                                        ) : (
                                                            <div {...getRootProps3()} style={dropzoneStyles}>
                                                                <input {...getInputProps3()} />
                                                                <Typography align="center" variant="h5">
                                                                    Arraste e solte uma imagem aqui ou clique para adicionar
                                                                </Typography>
                                                            </div>
                                                        )}
                                                        <Grid item xs={12} style={{ padding: 40 }}>
                                                            <TextField
                                                                variant="standard"
                                                                name="descricaoImagem3"
                                                                label="Descrição"
                                                                inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                required
                                                                id="descricaoImagem3"
                                                                value={descricaoImagem3}
                                                                onChange={(e) => setDescricaoImagem3(e.target.value)}
                                                                fullWidth
                                                                multiline
                                                                minRows={1}
                                                            />
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>


                                            <Grid item xs={3}>
                                                <Card>
                                                    <CardContent>
                                                        {imagemSelecionada4 ? (
                                                            <img
                                                                src={URL.createObjectURL(imagemSelecionada4)}
                                                                alt="Imagem Selecionada 4"
                                                                style={{ width: '100%', height: 'auto', marginBottom: '10px' }}
                                                            />
                                                        ) : (
                                                            <div {...getRootProps4()} style={dropzoneStyles}>
                                                                <input {...getInputProps4()} />
                                                                <Typography align="center" variant="h5">
                                                                    Arraste e solte uma imagem aqui ou clique para adicionar
                                                                </Typography>
                                                            </div>
                                                        )}
                                                        <Grid item xs={12} style={{ padding: 40 }}>
                                                            <TextField
                                                                variant="standard"
                                                                name="descricaoImagem4"
                                                                label="Descrição"
                                                                inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                required
                                                                id="descricaoImagem4"
                                                                value={descricaoImagem4}
                                                                onChange={(e) => setDescricaoImagem4(e.target.value)}
                                                                fullWidth
                                                                multiline
                                                                minRows={1}
                                                            />
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>

                                        </Grid>

                                    </Grid>

                                    <Grid
                                        value={value} index={2}
                                        style={{ paddingTop: 30 }}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        spacing={2}
                                    >



                                        <Grid item xs={12} style={{ padding: 40 }}
                                            container
                                            alignItems="center"
                                            justifyContent="center"
                                        >

                                            <Grid item xs={8}>
                                                <Card>
                                                    <CardContent>
                                                        {videoSelecionado1 ? (
                                                            <video
                                                                controls
                                                                src={URL.createObjectURL(videoSelecionado1)}
                                                                alt="Vídeo Selecionado"
                                                                style={{ width: '100%', height: '100%', marginBottom: '10px' }}
                                                            />
                                                        ) : (
                                                            <div {...getRootVideoProps1()} style={dropzoneStyles}>
                                                                <input {...getInputVideoProps1()} />
                                                                <Typography align="center" variant="h5">
                                                                    Arraste e solte um vídeo aqui ou clique para adicionar
                                                                </Typography>
                                                            </div>
                                                        )}
                                                        <Grid item xs={12} style={{ padding: 40 }}>
                                                            <TextField
                                                                variant="standard"
                                                                name="descricaoVideo1"
                                                                label="Descrição"
                                                                inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                required
                                                                id="descricaoVideo1"
                                                                value={descricaoVideo1}
                                                                onChange={(e) => setDescricaoVideo1(e.target.value)}
                                                                fullWidth
                                                                multiline
                                                                minRows={1}
                                                            />
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>

                                            <Grid item xs={8}>
                                                <Card>
                                                    <CardContent>
                                                        {videoSelecionado2 ? (
                                                            <video
                                                                controls
                                                                src={URL.createObjectURL(videoSelecionado2)}
                                                                alt="Vídeo Selecionado"
                                                                style={{ width: '100%', height: '100%', marginBottom: '10px' }}
                                                            />
                                                        ) : (
                                                            <div {...getRootVideoProps2()} style={dropzoneStyles}>
                                                                <input {...getInputVideoProps2()} />
                                                                <Typography align="center" variant="h5">
                                                                    Arraste e solte um vídeo aqui ou clique para adicionar
                                                                </Typography>
                                                            </div>
                                                        )}
                                                        <Grid item xs={12} style={{ padding: 40 }}>
                                                            <TextField
                                                                variant="standard"
                                                                name="descricaoVideo2"
                                                                label="Descrição"
                                                                inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                required
                                                                id="descricaoVideo2"
                                                                value={descricaoVideo2}
                                                                onChange={(e) => setDescricaoVideo2(e.target.value)}
                                                                fullWidth
                                                                multiline
                                                                minRows={1}
                                                            />
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>

                                            <Grid item xs={8}>
                                                <Card>
                                                    <CardContent>
                                                        {videoSelecionado3 ? (
                                                            <video
                                                                controls
                                                                src={URL.createObjectURL(videoSelecionado3)}
                                                                alt="Vídeo Selecionado"
                                                                style={{ width: '100%', height: '100%', marginBottom: '10px' }}
                                                            />
                                                        ) : (
                                                            <div {...getRootVideoProps3()} style={dropzoneStyles}>
                                                                <input {...getInputVideoProps3()} />
                                                                <Typography align="center" variant="h5">
                                                                    Arraste e solte um vídeo aqui ou clique para adicionar
                                                                </Typography>
                                                            </div>
                                                        )}
                                                        <Grid item xs={12} style={{ padding: 40 }}>
                                                            <TextField
                                                                variant="standard"
                                                                name="descricaoVideo3"
                                                                label="Descrição"
                                                                inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                required
                                                                id="descricaoVideo3"
                                                                value={descricaoVideo3}
                                                                onChange={(e) => setDescricaoVideo3(e.target.value)}
                                                                fullWidth
                                                                multiline
                                                                minRows={1}
                                                            />
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        value={value} index={3}
                                        style={{ paddingTop: 30 }}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        spacing={2}
                                    >




                                        <Grid item xs={12} style={{ padding: 40 }}
                                            container
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <Grid item xs={8}>
                                                <Card>
                                                    <CardContent>
                                                        {arquivoSelecionado1 ? (

                                                            <div
                                                                href={URL.createObjectURL(arquivoSelecionado1)}
                                                                onClick={() => window.open(URL.createObjectURL(arquivoSelecionado1), '_blank')}
                                                                onMouseOver={() => console.log('URL:', URL.createObjectURL(arquivoSelecionado1))}
                                                                style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '200px', height: '200px' }}>
                                                                <InsertDriveFileIcon style={{ fontSize: 48, color: "#1976d2" }} />
                                                            </div>


                                                        ) : (
                                                            <div {...getRootArquivoProps1()} style={dropzoneStyles}>
                                                                <input {...getInputArquivoProps1()} />
                                                                <Typography align="center" variant="h5">
                                                                    Arraste e solte um arquivo aqui ou clique para adicionar
                                                                </Typography>
                                                            </div>
                                                        )}
                                                        <Grid item xs={12} style={{ padding: 40 }}>
                                                            <TextField
                                                                variant="standard"
                                                                name="descricaoArquivo1"
                                                                label="Descrição"
                                                                inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                required
                                                                id="descricaoArquivo1"
                                                                value={descricaoArquivo1}
                                                                onChange={(e) => setDescricaoArquivo1(e.target.value)}
                                                                fullWidth
                                                                multiline
                                                                minRows={1}
                                                            />
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>

                                            <Grid item xs={8}>
                                                <Card>
                                                    <CardContent>
                                                        {arquivoSelecionado2 ? (
                                                            <div
                                                                href={URL.createObjectURL(arquivoSelecionado2)}
                                                                onClick={() => window.open(URL.createObjectURL(arquivoSelecionado2), '_blank')}
                                                                onMouseOver={() => console.log('URL:', URL.createObjectURL(arquivoSelecionado2))}
                                                                style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '200px', height: '200px' }}>
                                                                <InsertDriveFileIcon style={{ fontSize: 48, color: "#1976d2" }} />
                                                            </div>
                                                        ) : (
                                                            <div {...getRootArquivoProps2()} style={dropzoneStyles}>
                                                                <input {...getInputArquivoProps2()} />
                                                                <Typography align="center" variant="h5">
                                                                    Arraste e solte um arquivo aqui ou clique para adicionar
                                                                </Typography>
                                                            </div>
                                                        )}
                                                        <Grid item xs={12} style={{ padding: 40 }}>
                                                            <TextField
                                                                variant="standard"
                                                                name="descricaoArquivo2"
                                                                label="Descrição"
                                                                inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                required
                                                                id="descricaoArquivo2"
                                                                value={descricaoArquivo2}
                                                                onChange={(e) => setDescricaoArquivo2(e.target.value)}
                                                                fullWidth
                                                                multiline
                                                                minRows={1}
                                                            />
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>

                                            <Grid item xs={8}>
                                                <Card>
                                                    <CardContent>
                                                        {arquivoSelecionado3 ? (
                                                            <div
                                                                href={URL.createObjectURL(arquivoSelecionado3)}
                                                                onClick={() => window.open(URL.createObjectURL(arquivoSelecionado3), '_blank')}
                                                                onMouseOver={() => console.log('URL:', URL.createObjectURL(arquivoSelecionado3))}
                                                                style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '200px', height: '200px' }}>
                                                                <InsertDriveFileIcon style={{ fontSize: 48, color: "#1976d2" }} />
                                                            </div>
                                                        ) : (
                                                            <div {...getRootArquivoProps3()} style={dropzoneStyles}>
                                                                <input {...getInputArquivoProps3()} />
                                                                <Typography align="center" variant="h5">
                                                                    Arraste e solte um arquivo aqui ou clique para adicionar
                                                                </Typography>
                                                            </div>
                                                        )}
                                                        <Grid item xs={12} style={{ padding: 40 }}>
                                                            <TextField
                                                                variant="standard"
                                                                name="descricaoArquivo3"
                                                                label="Descrição"
                                                                inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                required
                                                                id="descricaoArquivo3"
                                                                value={descricaoArquivo3}
                                                                onChange={(e) => setDescricaoArquivo3(e.target.value)}
                                                                fullWidth
                                                                multiline
                                                                minRows={1}
                                                            />
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>

                                        </Grid>
                                    </Grid>

                                </SwipeableViews>


                            </Grid>




                        </Grid>



                    }

                </div>
            </ThemeProviderV4>
        </ThemeProvider>
    );
}
